var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',[_c('page-header',{attrs:{"actions":_vm.actions,"header":_vm.pageHeader}}),_c('div',{staticClass:"content"},[_c('admin-table',_vm._b({ref:"table",scopedSlots:_vm._u([{key:"booking_amount",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("currency")(item.booking_amount,item.currency_label))+" ")]}},{key:"amount",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("currency")(item.amount,item.currency_label))+" ")]}}])},'admin-table',_vm.tableProps,false))],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }